/** Activo en Playwright (webServer / e2e/.env) para habilitar atajos de prueba sin depender del modo sucursal. */
export const isPlaywrightE2E = process.env.EXPO_PUBLIC_PLAYWRIGHT_E2E === '1';

export type PlaywrightE2EPosScan = (rawCode: string) => void | Promise<void>;

/** Seteado por Playwright `addInitScript` antes de cargar la app (no requiere rebuild de Metro). */
export function isPlaywrightE2EBridge(): boolean {
  if (typeof window === 'undefined') return false;
  return Boolean(window.__VUELTO_E2E_POS_SCAN_BRIDGE__);
}

declare global {
  interface Window {
    __VUELTO_E2E_POS_SCAN__?: PlaywrightE2EPosScan;
    __VUELTO_E2E_POS_SCAN_BRIDGE__?: boolean;
    __VUELTO_E2E_WEB_ONLINE_WRITES__?: boolean;
    /** Pull full catálogo (marcas/proveedores/productos) tras seed remoto vía RPC. */
    __VUELTO_E2E_FORCE_CATALOG_SYNC__?: () => Promise<void>;
    __E2E_BARCODE_LOOKUP_MOCK__?: unknown;
  }
}
